<template>
  <div style="height: 100%;background-color: white">
    <div style="height: 50px;padding-top: 20px;margin: 0 20px">
      <el-input prefix-icon="el-icon-search" placeholder="输入老人姓名" v-model="searchKeyword" style="width: 220px"></el-input>
      <el-button type="primary" @click="getSearchData()">查询</el-button>
    </div>
    <div style="max-height: calc(100% - 120px);overflow-y: auto;margin: 0 20px">
      <el-table :data="tableData" border highlight-current-row ref="singleTable">
        <el-table-column
          type="index"
          label="编号"
          width="70"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="老人姓名"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="房间"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="接待人"
          min-width="80"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="入住时间"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="结束时间"
          min-width="100"
          align="center">
        </el-table-column>
        <el-table-column
          prop=""
          label="备注"
          min-width="80"
          align="center">
        </el-table-column>
      </el-table>
    </div>
    <div style="margin-top: 10px;height: 40px;text-align: center">
      <el-pagination v-fixZoom @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="currentPage"
                     :page-sizes="[10, 20, 50, 100]" :page-size="pageSize" :total="totalCells"
                     layout="total, sizes, prev, pager, next, jumper">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'oldPersonStatistics',
  data () {
    return {
      pageSize: 10,
      currentPage: 1,
      totalCells: 0,
      tableData: [{id: 1, name: 11}],
      searchKeyword: ''
    }
  },
  created () {
  },
  methods: {
    getSearchData () {},
    handleSizeChange (val) {
      this.pageSize = val
    },
    handleCurrentChange (val) {
      this.currentPage = val
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/oldPersonHome/oldPersonStatistics.vue